module.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCA1MCIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxjaXJjbGUgY3g9IjI1IiBjeT0iMjUiIGZpbGw9IiNlM2Q4MjQiIHI9IjI0LjYiLz48Y2lyY2xlIGN4PSItNDIuNCIgY3k9IjI1IiBmaWxsPSIjZTI0NzI2IiByPSIyNC42Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map/Yellow-Moderate.svg
// module id = 2405
// module chunks = 1